export { default as ArrivalTimeTab } from "./ArrivalTimeTab";
export { default as AttachmentsTab } from "./AttachmentsTab";
export { default as FinishTab } from "./FinishTab";
export { default as OverviewTab } from "./OverviewTab";
export { default as PolicemanTab } from "./PolicemanTab";
export { default as OccurrenceDataTab } from "./OccurrenceDataTab";
export { default as VehicleDataTab } from "./VehicleDataTab";
export { default as LastLocationsTab } from "./LastLocationsTab";
export { default as WhatsappTab } from "./WhatsappTab";
export { default as PaymentTab } from "./PaymentTab";
export { default as HistoryTab } from "./HistoryTab";
export { default as RouteViewTab } from "./RouteViewTab"
export { default as CommentsTab } from "./CommentsTab"
export { MasterCommentsTab } from './MasterCommentsTab' 